module.exports = __webpack_public_path__ + "static/media/txt-record.8b4be410.svg";